import {
	ClientLinkShare,
	LinkSecurity
} from 'sharebase/domain';
import { Acl } from 'phoenix/domain';

class ShareListItem {
	public deleteExpanded:boolean = false;
	constructor(
		public acl:Acl
	){
	}
}

require('./shareList.styles');
const template = require('./shareList.template');

/**
 * @ngdoc directive
 * @name sharebase.directive:sbShareList
 * @module sharebase
 * @restrict E
 * @description
 *
 * `sbShareList` is a list of an items shares
 *
 * @param {string} objectType The type of object, valid values foldder or document
 *
 * @param {array} shares An array of shares to display in the list.
 * 
 * @usage
 *
 * <sb-share-list object-type='folder' shares='datastore.shares' click-event />
 */
export function ShareListDirective() {
	return {
		restrict: 'E',
		controller: ShareListController,
		controllerAs: 'vm',
		bindToController: true,
		template,
		scope: {
			shares: '=',
			links: '=',
			inheritedLinks: '=',
			inheritedShares: '=',
			deleteShare: '=',
			deleteLink: '=',
			revokeAccess: '=',
			onClick: '=',
			objectType: '@',
			objectName: '@',
			filterPhrase: '=',
			canModify: '=?',
			sort: '=?',
			newShareAction: '=',
			newShareMessage: '@',
			newLinkAction: '=',
			newLinkMessage: '@',
			activeList:'=?',
			deletePattern: '@'
		},
		link: function (scope, element) {
			if(scope.vm.sort) {
				scope.$watch('vm.shares', function(newShares, oldShares) {
					if(newShares && newShares.length > 0 && newShares !== oldShares) {
						newShares.sort(function(a, b){
							if(a.userName.toLowerCase() === b.userName.toLowerCase()) {
								return 0;
							} 
							else {
								return a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1;
							}
						});
						scope.vm.shareListItems = newShares.map(share => new ShareListItem(share));
					}
				});
			}		
		}
	};
}

function ShareListController(
	$window, 
	$q, 
	$mdDialog, 
	pxClipboardService, 
	sbToastService,
	gettextCatalog
) {
	var vm = this;
	vm.isLibrary = vm.objectType === 'library' ? true : false;
	vm.canModify = typeof(vm.canModify) === 'boolean' ? vm.canModify : true;
	vm.sort = typeof(vm.sort) === 'boolean' ? vm.sort : true;
	vm.deletePattern = vm.deletePattern ? vm.deletePattern : 'dialog';		
	vm.emailSubject = gettextCatalog.getString('You\'ve been shared {{contentName}}',{contentName: encodeURIComponent(vm.objectName) });
	vm.onDeleteShare = onDeleteShare;
	vm.onDeleteLink = onDeleteLink;
	vm.promptForShareDelete = promptForShareDelete;
	vm.promptForLinkDelete = promptForLinkDelete;
	vm.copyURL = copyURL;
	vm.openURL = openURL;
	vm.doesLinkExpire = doesLinkExpire;
	vm.activeList = typeof(vm.activeList) === 'number' ? vm.activeList : 0;
	vm.LinkSecurity = LinkSecurity;
	vm.shareListItems = vm.shares.map(share => new ShareListItem(share));

	function promptForShareDelete(ev, share:ShareListItem) {
		if(vm.deletePattern === 'dialog'){
			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('Would you like to remove this share?'))
				.textContent(gettextCatalog.getString('{{name}} will no longer have {{right}} rights.', {
					name: share.acl.userName,
					right: share.acl.rightName.toLowerCase()
				}))
				.ariaLabel(gettextCatalog.getString('Remove share'))
				.targetEvent(ev)
				.ok(gettextCatalog.getString('Remove'))
				.cancel(gettextCatalog.getString('Cancel'));

			$mdDialog.show(confirm)
				.then(function () {
					return onDeleteShare(share.acl);				
				}, angular.noop);
		}
		else{
			share.deleteExpanded = !share.deleteExpanded;
		}			
	}

	function promptForLinkDelete(ev, link) {
		if(vm.deletePattern === 'dialog'){
			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('Would you like to revoke this link?'))
				.ariaLabel(gettextCatalog.getString('Revoke link'))
				.targetEvent(ev)
				.ok(gettextCatalog.getString('Revoke'))
				.cancel(gettextCatalog.getString('Cancel'));

			$mdDialog.show(confirm)
				.then(function () {
					return onDeleteLink(link);				
				}, angular.noop);
		}
		else{
			link.DeleteExpanded = !link.DeleteExpanded;
		}			
	}

	function onDeleteShare(share:Acl){
		return vm.deleteShare(share)
			.then(function() {
				sbToastService.showSimple(gettextCatalog.getString('Share removed successfully.'));
			})
			.catch(function() {
				sbToastService.showSimple(gettextCatalog.getString('Failed to remove share.'));
			});
	}

	function onDeleteLink(link){
		if(link.DeleteExpanded){
			delete link.DeleteExpanded;
		}
		return vm.deleteLink(link)
			.then(function() {
				sbToastService.showSimple(gettextCatalog.getString('Link revoked successfully.'));
			})
			.catch(function() {
				sbToastService.showSimple(gettextCatalog.getString('Failed to revoke link.'));
			});
	}

	function openURL(url){
		$window.open(url);
	}

	function copyURL(link:ClientLinkShare) {
		try {
			pxClipboardService.copy(link.LinkUrl);
			sbToastService.showSimple(gettextCatalog.getString('Link copied to clipboard.'));
		}
		catch (e) {
			sbToastService.showSimple(gettextCatalog.getString('Could not copy link.'));
		}

	}
	// Returns true if link expires, false otherwise
	function doesLinkExpire(link) {
		// If the year is equal to 9999, then the link does not expire
		return (new Date(link.DateExpires)).getFullYear() !== 9999;
	}
	
}

ShareListController.$inject = [
	'$window',
	'$q',
	'$mdDialog',
	'pxClipboardService',
	'sbToastService',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/shareList/shareList.ts